/** 견적 폼 안내 문구용 숫자 포맷 (원화·할인율). */

const percentFormat = new Intl.NumberFormat('ko-KR', {
  style: 'percent',
  maximumFractionDigits: 20,
});

export const formatWon = (value: number) => value.toLocaleString('ko-KR');

/** 0.5 → "50%" (소수 할인율도 반올림하지 않는다) */
export const formatDiscountRate = (rate: number) => percentFormat.format(rate);
